exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.ItemPreview__itemImage___1oqdfXmH {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/*\n  So to remove a border for images that do not have src\n  https://stackoverflow.com/questions/10441362/how-can-i-remove-the-border-around-an-image-without-a-source\n*/\n.ItemPreview__itemImage___1oqdfXmH:not([src]) {\n  display: none;\n}\n", ""]);
// Exports
exports.locals = {
	"itemImage": "ItemPreview__itemImage___1oqdfXmH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/configurator/components/Preview/ItemPreview.vue?vue&type=style&index=0&module=true&lang=css&
// module id = AsUT
// module chunks = 3